<script setup>
import { ref } from 'vue';

const IMAGES_SIDEBAR_URL = import.meta.env.VITE_IMAGES_SIDEBAR_URL;

const emit = defineEmits(['onSidebarClosed']);

const isOpen = ref(false);

function open() {
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

function isOpened() {
  return isOpen.value;
}

defineExpose({
  open, close, isOpened
});
</script>


<template>
  <div v-show="isOpen" id="imagesSidebar">
    <div class="px-4 py-3 is-flex is-justify-content-space-between is-align-content-center has-background-white">
      <header class="has-text-black has-text-weight-semibold is-size-5">
        AI Images
      </header>
      <a class="is-flex is-align-content-center" @click="() => { emit('onSidebarClosed'); }">
        <img src="@/assets/images/x-close.svg">
      </a>
    </div>
    <iframe :src="IMAGES_SIDEBAR_URL" class="react-iframe" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<style>
 #imagesSidebar {
   height: 100%;
 }

 #imagesSidebar>iframe {
   height: 100%;
   width: 100%;
 }
</style>
